import { ChangeEventHandler, Dispatch, FC, SetStateAction } from "react";
import TableHeader from "../../../assets/components/Table/TableHeader";
import DownloadButton from "../../../assets/components/DownloadButton/DownloadButton";
import warning from "../../../assets/components/DownloadButton/Img/warning.svg";
import {
    Page,
    PaginationBar,
} from "../../../assets/components/PaginationBar/PaginationBar";
import { IoloDetailInfo } from "../../../redux/RTKQuery/api";

const IMPORT_TOOLTIP = (
    <div className="download_button__tooltip_content">
        <img
            src={warning}
            className="download_button__tooltip_icon"
            alt="warning"
        />
        <span>
            Import Iolo licenses from CSV.
            <br />
            This action requires time!
        </span>
    </div>
);

interface Props {
    dataTable: IoloDetailInfo[];
    pageNumber: Page;
    currentSizePage: number;
    pageSize: number;
    totalLicenses: number;
    setCurrentPage: Dispatch<SetStateAction<Page>>;
    onImportCSV: ChangeEventHandler<HTMLInputElement>;
    isImporting: boolean;
}

const IoloLicenseKeysTableHeader: FC<Props> = ({
    pageSize,
    pageNumber,
    currentSizePage,
    dataTable,
    totalLicenses,
    setCurrentPage,
    onImportCSV,
    isImporting,
}) => {
    return (
        <TableHeader
            title="List of licenses"
            dataTableLength={dataTable.length}
            pageSize={currentSizePage}
            headerActions={
                <DownloadButton
                    action="upload"
                    onChange={onImportCSV}
                    disabled={isImporting}
                    accept=".csv,text/csv"
                    tooltipContent={IMPORT_TOOLTIP}
                />
            }
        >
            <PaginationBar
                currentPage={pageNumber as number}
                currentPageHandler={setCurrentPage}
                totalItems={totalLicenses}
                pageSize={pageSize}
            />
        </TableHeader>
    );
};

export default IoloLicenseKeysTableHeader;
